import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const licenceSuspensionQuestion = () => ({
    "collection-agency" : {
        header : "History of business licence suspension",
        text : ["Has your company had a business licence refused, suspended or revoked in Nova Scotia or another province?"],
        navigation : {
            yes : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS,
            no : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION
        }
    },
    "debt-management-agency" : {
        header : "History of business licence suspension",
        text : ["Has your company had a business licence refused, suspended or revoked in Nova Scotia or another province?"],
        navigation : {
            yes : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS,
            no : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION
        }
    }, 
    "collection-agency-collector" : {
        header : "History of business licence suspension",
        text : ["Has the applicant had a business licence refused, suspended or revoked in Nova Scotia or another province?"],
        navigation : {
            yes : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS,
            no : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW
        }
    },
    "debt-management-agent" : {
        header : "History of business licence suspension",
        text : ["Has the applicant had a business licence refused, suspended or revoked in Nova Scotia or another province?"],
        navigation : {
            yes : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS,
            no : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW
        }
    },
    header : "History of business licence suspension",
    text : ["Has your company had a business licence refused, suspended or revoked in Nova Scotia or another province?"],
    navigation : {
        yes : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS,
        no : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION
    }
})

const licenceSuspensionSlice = createSlice({
    name : 'licenceSuspensionQuestion',
    initialState: licenceSuspensionQuestion(),
    reducers: {
        setLicenceSuspensionQuestionAnswer(state, action) {
            state.licenSuspensionQuestionAnswer = action.payload
        }
    }
})

export const {setLicenceSuspensionQuestionAnswer} = licenceSuspensionSlice.actions

export const licenceSuspensionQuestionReducer = licenceSuspensionSlice.reducer

const licenceSuspensionDetails = () => ({
    "collection-agency" : {
        header : "History of business licence suspension",
        text : ["Provide more information about the business licence your company had refused, suspended or revoked in Nova Scotia or another province or territory."],
        headerRenewal : "History of business licence suspension",
        textRenewal : [
            "Review your history of licence suspension. If your company had any business licences suspended since your last renewal, add them to your suspension history.",
            "If a previously suspended, revoked, or refused license has been reinstated, edit your information to include the change."
        ],
        navigation : {
            next : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION,
            nextRenewal : ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS
        }
    }, 
    "debt-management-agency" : {
        header : "History of business licence suspension",
        text : ["Provide more information about the business licence your company had refused, suspended or revoked in Nova Scotia or another province or territory."],
        headerRenewal : "History of business licence suspension",
        textRenewal : [
            "Review your history of licence suspension. If your company had any business licences suspended since your last renewal, add them to your suspension history.",
            "If a previously suspended, revoked, or refused license has been reinstated, edit your information to include the change."
        ],
        navigation : {
            next : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION,
            nextRenewal : ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS
        }
    }, 
    "collection-agency-collector" : {
        header : "History of business licence suspension",
        text : ["Provide more information about business licences refused, suspended or revoked in Nova Scotia or another province or territory."],
        headerRenewal : "History of business licence suspension",
        textRenewal : [
            "Review applicant's history of licence suspension. If applicant had any business licences suspended since your last renewal, add them to applicant's suspension history.",
            "If a previously suspended, revoked, or refused license has been reinstated, edit your information to include the change."
        ],
        navigation : {
            next : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW,
            nextRenewal : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW
        }
    },
    "debt-management-agent" : {
        header : "History of business licence suspension",
        text : ["Provide more information about business licences refused, suspended or revoked in Nova Scotia or another province or territory."],
        headerRenewal : "History of business licence suspension",
        textRenewal : [
            "Review applicant's history of licence suspension. If applicant had any business licences suspended since your last renewal, add them to applicant's suspension history.",
            "If a previously suspended, revoked, or refused license has been reinstated, edit your information to include the change."
        ],
        navigation : {
            next : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW,
            nextRenewal : ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW
        }
    },
    header : "History of business licence suspension",
    text : ["Provide more information about the business licence your company had refused, suspended or revoked in Nova Scotia or another province or territory."],
    headerRenewal : "History of business licence suspension",
    textRenewal : [
        "Review your history of licence suspension. If you had any business licences suspended since your last renewal, add them to your suspension history.",
        "If a previously suspended, revoked, or refused license has been reinstated, edit your information to include the change."
    ],
    navigation : {
        next : ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION,
        nextRenewal : ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS
    }
})

const licenceSuspensionDetailsSlice = createSlice({
    name : 'licenceSuspensionDetails',
    initialState: licenceSuspensionDetails(),
    reducers: {}
})

// export const { setLicenceSuspensionDetails } = licenceSuspensionDetailsSlice.actions

export const licenceSuspensionDetailsReducer = licenceSuspensionDetailsSlice.reducer
